import MapView = require("esri/views/MapView");

import { Polyline } from "esri/geometry";
import watchUtils = require("esri/core/watchUtils");
import BasemapGallery = require("esri/widgets/BasemapGallery");
import CoordinateConversion = require("esri/widgets/CoordinateConversion");
import webMercatorUtils = require("esri/geometry/support/webMercatorUtils");
import Expand = require("esri/widgets/Expand");
import Home = require("esri/widgets/Home");
import { TextSymbol } from "esri/symbols";
import LayerList = require("esri/widgets/LayerList");
// need to force import of Legend, because LayerList requires it...
import urlUtils = require("esri/core/urlUtils");
import "esri/widgets/Legend";
import * as baseGroup from "../../data/Layers/baseGroup";
import * as boundaryLayers from "../../data/Layers/boundaryLayers";
import * as layerSource from "../../data/Layers/layerSource";
import * as otherLayers from "../../data/Layers/otherLayers";
import * as pavement from "../../data/Layers/pavement";
import * as programming from "../../data/Layers/programming";
import * as roadwayClassification from "../../data/Layers/roadwayClassification";
import * as structures from "../../data/Layers/structures";
import * as trafficLayers from "../../data/Layers/trafficCount";
import { pinLayer } from "../../data/Layers/pushPinLayer";
import { illinoisExtent } from "../Toolbar/fullExtentTool";

import Info from "./../Info";
import Mask from "./../Mask";
import ToolBar from "./../Toolbar";
import ZoomTo from "./../ZoomTo";

import Basemap = require("esri/Basemap");
import FeatureLayer = require("esri/layers/FeatureLayer");
import Layer = require("esri/layers/Layer")
import GroupLayer = require("esri/layers/GroupLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import TileLayer = require("esri/layers/TileLayer");
import LocalBasemapsSource = require("esri/widgets/BasemapGallery/support/LocalBasemapsSource");
import Print = require("esri/widgets/Print");
import ScaleBar = require("esri/widgets/ScaleBar");
import Search = require("esri/widgets/Search");
import Zoom = require("esri/widgets/Zoom");
import Locator = require("esri/rest/locator");
import LocatorSearchSource = require("esri/widgets/Search/LocatorSearchSource");
import Query = require('esri/rest/support/Query');
import TemplateOptions = require('esri/widgets/Print/TemplateOptions');
import PopupTemplate = require('esri/PopupTemplate');
import Graphic = require('esri/Graphic');
import Feature = require('esri/widgets/Feature');
import Point = require('esri/geometry/Point');
import PictureMarkerSymbol = require('esri/symbols/PictureMarkerSymbol');
import Geometry = require('esri/geometry/Geometry');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import SimpleMarkerSymbol = require('esri/symbols/SimpleMarkerSymbol');
import * as Msal from "msal";
import VectorTileLayer = require("esri/layers/VectorTileLayer");

export let layerList: LayerList;
export let layerListExpand: Expand;
export let tbExpand: Expand;

export let mpoNames = [{ id: "None", name: "Select MPO", index: -1 }];
export let urbanAreasNames = [{ id: "None", name: "Select Urban Area", index: -1 }];
export let countyNames = [{ id: "None", name: "Select County", index: -1 }];
export let districtNames = [{ id: "None", name: "Select District", index: -1 }];
export let highlightColor = [176, 255, 255, 1];

// tslint:disable-next-line: variable-name
const hexagonLayer_Imagery = new MapImageLayer({
  url: "https://services.hxgncontent.com/streaming/rest/services/HxGN_Imagery/MapServer",
});  

const streetsLayer = new MapImageLayer ({
  url: "http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer"  
});

export const localBasemapsSource = new LocalBasemapsSource({
  basemaps: [
    Basemap.fromId("streets-vector"),
    Basemap.fromId("topo-vector"),
    Basemap.fromId("hybrid"),
    new Basemap({portalItem: {id: "f33a34de3a294590ab48f246e99958c9"}}), // National Geographic
    Basemap.fromId("gray-vector"),
  ]
});

export const localBasemapsSourceInternal = new LocalBasemapsSource({
  basemaps: [
    Basemap.fromId("streets-vector"),
    Basemap.fromId("topo-vector"),
    Basemap.fromId("hybrid"),
    new Basemap({portalItem: {id: "f33a34de3a294590ab48f246e99958c9"}}), // National Geographic
    Basemap.fromId("gray-vector"),
    new Basemap({title:"Hexagon Imagery", baseLayers: [streetsLayer, hexagonLayer_Imagery], thumbnailUrl:"./assets/Hexagon.jpg"}),
  ]
});

let toolbar: ToolBar;
let view: MapView;
let basemapGallery: BasemapGallery;
let printWidget: Print;
let selectedLayers = [] as string[];
let selectedLayersId = [] as string[];
let clickPoint:Point|null = null;
let infoPane:Info;
export let authLoggedIn:boolean = false;
export let loggedInAccount:Msal.Account;
export let authIsPrivileged:boolean = false;
export let authIsInternal:boolean = false;

export function setIsPrivileged(val:boolean) {
  authIsPrivileged = val;
}

export function setIsInternal(val:boolean) {
  authIsInternal = val;

  loadBasemapGallery();
}

export function setClickPoint(inPoint:Point|null) {
  clickPoint = inPoint;
}
let topLeft:HTMLDivElement;

const clickSymbol = new PictureMarkerSymbol({
  "url": "https://static.arcgis.com/images/Symbols/Animated/ConstantBlueStrobeMarkerSymbol.png",
});

const zoomTo = new ZoomTo();

function defineActions(event: any) {
  // The event object contains an item property. is is a ListItem referencing the
  // associated layer and other properties. You can control the visibility of the
  // item, its title, and actions using this object.

  // console.log("defineAction event.item.layer.title = ", event.item.layer.title, " id = ", event.item.layer.id, " layerId = ", event.item.layer.layerId);
  try {
    const item = event.item;
    if (
      item.layer.legendEnabled &&
      (item.layer.type !== "group" ||
        (item.layer instanceof GroupLayer && item.layer.listMode === "hide-children") ||
        item.layer === structures.structuresGroupLayer ||
        item.layer === programming.programmingGroupLayer)
    ) {
      // don't show legend twice
      if (
        item.layer !== structures.structuresGroupLayer &&
        item.layer !== programming.programmingGroupLayer
      ) {
        item.panel = {
          content: "legend"
        };
      }
      // An array of objects defining actions to place in the LayerList. By making
      // this array two-dimensional, you can separate similar actions into separate
      // groups with a breaking line.

      const searchParams = returnSearchParamsFromLayer(item.layer);

      if (searchParams && searchParams.search !== "") {
        item.actionsSections = [
          [
            {
              title: "Zoom To",
              className: "esri-icon-search",
              id: "search"
            }
          ]
        ];
      }
    } else {
      // console.log("skipped = ", item.layer.title);
    }
  } catch (error) {
    console.error("Error: in defineActions " + error.message);
  }
}

function capitalizeFirstLetter(line: string) {
  return line[0].toUpperCase() + line.slice(1).toLowerCase();
}

export function titleCase(line: string) {
  if (line.trim() === "") {
    return "";
  }
  return line
    .split(" ")
    .map(x => capitalizeFirstLetter(x))
    .join(" ");
}

export function autocomplete(inp : HTMLInputElement|null, arr:string[], norm:any=null) {
  /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/
  let currentFocus = -1;
  closeAllLists();    
  /*execute a function when someone writes in the text field:*/
  if (!inp) {
    return;
  }
  const val = norm ? norm(inp.value) : inp.value;
  /*close any already open lists of autocompleted values*/
  if (!val) { return false;}
  currentFocus = -1;
  /*create a DIV element that will contain the items (values):*/
  const a = document.createElement("DIV");
  a.setAttribute("id", inp.id + "autocomplete-list");
  a.setAttribute("class", "autocomplete-items");
  /*append the DIV element as a child of the autocomplete container:*/
  if (inp.parentNode) {
    inp.parentNode.appendChild(a);
  }
  /*for each item in the array...*/
  if (arr.length > 1 || (arr.length === 1 && val.toUpperCase() !== arr[0].toUpperCase())) { // don't add suggestion if there is only one and matches input
    for (const item of arr) {
      /*check if the item starts with the same letters as the text field value:*/
      if (item.substr(0, val.length).toUpperCase() === val.toUpperCase()) {
        /*create a DIV element for each matching element:*/
        const b = document.createElement("DIV");
        /*make the matching letters bold:*/
        b.innerHTML = "<strong>" + item.substr(0, val.length).replace(" ", "&nbsp;") + "</strong>";
        b.innerHTML += item.substr(val.length).replace(" ", "&nbsp;");
        /*insert a input field that will hold the current array item's value:*/
        b.innerHTML += "<input type='hidden' value='" + item + "'>";
        /*execute a function when someone clicks on the item value (DIV element):*/
        b.addEventListener("click", function(event) {
            /*insert the value for the autocomplete text field:*/
            inp.value = this.getElementsByTagName("input")[0].value;
            // IE 11 workaround
            let e:Event;
            if(typeof(Event) === 'function') {
                e = new Event('input');
            }else{
                e = document.createEvent('Event');
                e.initEvent('input', true, true);
            }
            inp.dispatchEvent(e);
            /*close the list of autocompleted values,
            (or any other open lists of autocompleted values:*/
            closeAllLists();
        });
        a.appendChild(b);
        // if (a.childElementCount >= 7) {
        //   break;
        // }
      }
    }
  }
  /*execute a function presses a key on the keyboard:*/
  inp.addEventListener("keydown", function(e) {
      const list = document.getElementById(this.id + "autocomplete-list") as HTMLDivElement;
      if (list) {
        const x = list.getElementsByTagName("div");
        if (x && x.length > 0) {
          if (e.keyCode === 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode === 38) { // up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode === 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) {
                x[currentFocus].click();
              }
            }
          }
        }
      }
  });
  function addActive(x:HTMLCollectionOf<HTMLDivElement> ) {
    /*a function to classify an item as "active":*/
    if (!x) {
      return false;
    }
    /*start by removing the "active" class on all items:*/
    removeActive(x);
    if (currentFocus >= x.length) {
      currentFocus = 0;
    }
    if (currentFocus < 0) {
      currentFocus = (x.length - 1);
    }

    /*add class "autocomplete-active":*/
    x[currentFocus].classList.add("autocomplete-active");
  }
  function removeActive(x:HTMLCollectionOf<HTMLDivElement>) {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (let i = 0; i < x.length; i++) {
      x[i].classList.remove("autocomplete-active");
    }
  }
  function closeAllLists(elmnt:EventTarget|null = null) {
    /*close all autocomplete lists in the document,
    except the one passed as an argument:*/
    const x = document.getElementsByClassName("autocomplete-items");
    for (let i = 0; i < x.length; i++) {
      if (x[i] && elmnt !== x[i] && elmnt !== inp) {
        const parent = x[i].parentNode;
        if (parent !== null) {
          parent.removeChild(x[i]);
        }
      }
    }
  }
  /*execute a function when someone clicks in the document:*/
  document.addEventListener("click", (e) => {
      closeAllLists(e.target);
  });
}

function loadLists() {
  try {
    mpoNames = [{ id: "None", name: "Select MPO", index: -1 }];
    urbanAreasNames = [{ id: "None", name: "Select Urban Area", index: -1 }];
    countyNames = [{ id: "None", name: "Select County", index: -1 }];
    districtNames = [{ id: "None", name: "Select District", index: -1 }];
    
    // Get MPO Names for dropdown list
    const query = new Query({
      outFields: ["MPO_NAME"],
      orderByFields: ["MPO_NAME"],
      where: "1=1",
      returnGeometry: false
    });

    const sublayer = boundaryLayers.mpoAreasLayer.sublayers.getItemAt(0);
    sublayer
      .queryFeatures(query)
      .then(results => {
        results.features.forEach((feature, index) => {
          const mpoName = titleCase(feature.attributes.MPO_NAME);
          mpoNames.push({ id: mpoName, name: mpoName, index });
        });
      })
      .catch(error => {
        console.error("Error: in mpoAreasLayer " + error.message);
        this._showMessage("Error in mpoAreasLayer !!");
      });

    const query1 = new Query({
      outFields: ["URBAN_NAME"],
      orderByFields: ["URBAN_NAME"],
      where: "1=1",
      returnGeometry: false
    });

    const sublayer1 = boundaryLayers.urbanAreasLayer.sublayers.getItemAt(0);
    sublayer1
      .queryFeatures(query1)
      .then(results => {
        results.features.forEach((feature, index) => {
          const urbanName = titleCase(feature.attributes.URBAN_NAME);
          urbanAreasNames.push({ id: urbanName, name: urbanName, index });
        });
      })
      .catch(error => {
        console.error("Error: in urbanAreasLayer " + error.message);
        this._showMessage("Error in urbanAreasLayer !!");
      });

    const query2 = new Query({
      outFields: ["NAME_LC"],
      orderByFields: ["NAME_LC"],
      where: "NAME_LC <> '' ",
      returnGeometry: false
    });

    const sublayer2 = boundaryLayers.illinoisCounties.sublayers.getItemAt(0);
    sublayer2
      .queryFeatures(query2)
      .then(results => {
        results.features.forEach((feature, index) => {
          const countyName = titleCase(feature.attributes.NAME_LC);
          countyNames.push({ id: countyName, name: countyName, index });
        });
      })
      .catch(error => {
        console.error("Error: in illinoisCounties " + error.message);
        this._showMessage("Error in urbanAreasLayer !!");
      });

    const query3 = new Query({
      outFields: ["DISTRICT"],
      orderByFields: ["DISTRICT"],
      where: "1=1",
      returnGeometry: false
    });

    const sublayer3 = boundaryLayers.idotDistrictsLayer.sublayers.getItemAt(0);
    sublayer3
      .queryFeatures(query3)
      .then(results => {
        results.features.forEach((feature, index) => {
          const districtName = feature.attributes.DISTRICT;
          districtNames.push({ id: districtName, name: districtName, index });
        });
      })
      .catch(error => {
        console.error("Error: in illinoisCounties " + error.message);
        this._showMessage("Error in urbanAreasLayer !!");
      });
    } catch (error) {
      console.error("Error: in loadLists " + error.message);
}
}

export function watchGroupOpen() {
  try {
    // console.log("watchGroupOpen");
    const groupToggles = document.getElementsByClassName("esri-layer-list__child-toggle");
    for (let i=0; i<groupToggles.length; i++) {

      const groupToggle = groupToggles[i] as HTMLSpanElement;
      groupToggle.addEventListener("click", () => {
        setTimeout(renameTooltips, 100);
      });
    }
  } catch (error) {
    console.error("Error: in watchGroupOpen " + error.message);
  }
}

export function renameTooltips() {
  try {
    // console.log("renameToolTips");
    const tooltips = document.getElementsByClassName("esri-layer-list__item-title");
    
    for (let i=0; i<tooltips.length; i++) {

      const tooltip = tooltips[i] as HTMLSpanElement;
      // console.log("tooltip = ", tooltip);
      const parent = tooltip['offsetParent'];
      // console.log("parent ", parent);
      if (parent !== null) {
        const classList = parent['classList'];
        // console.log("classList ", classList);
        if (classList !== null) {

          const innerHTML = tooltip['innerHTML'];
          const prefix = innerHTML.slice(0, 3);

          // console.log(" innerHTML = ", innerHTML);

          switch (prefix) {
            case "MYP":
              tooltip['title'] = "Multi-Year Program";
              break;

            case "Ann":
              tooltip['title'] = "Annual Program";
              break;

            case "FTR":
              tooltip['title'] = "For The Record";
              break;
        
            case "CRS":
              tooltip['title'] = "Condition Rating Survey";
              break;
        
            case "IRI":
              tooltip['title'] = "International Roughness Index";
              break;
        
            case "Rut":
              tooltip['title'] = "Wheel Path Rutting";
              break;
        
            case "SOA":
              tooltip['title'] = "State of Acceptable Condition";
              break;
              
            default:
              // tooltip['title'] = tooltip['innerText'];
          }
        }
      }
    }
  } catch (error) {
    console.error("Error: in renameTooltips " + error.message);
  }
}

let ieWarned = false;

function afterLayersLoad() {
  try {
    console.log("\n\afterLayersLoad\n\n");

    const ua = window.navigator.userAgent;
    if (ieWarned === false && (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0)) { // IE 10+, Internet Explorer Check
      ieWarned = true;
      alert("Note: For an optimal experience, IROADS recommends using an up-to-date modern browser (e.g. Chrome, Edge, Firefox, Safari).")
    }

    // updateAuthStatus();
    // getAuthToken();

    loadLists();
    // layerList.operationalItems.sort((a, b) => a.layer.id.localeCompare(b.layer.id));

    layerList.operationalItems.forEach(item => {
      const groupLayer: GroupLayer = item.layer as GroupLayer;
      if (groupLayer && groupLayer.layers) {
        
        watchUtils.watch(groupLayer, "visible", () => _onVisibilityChange(groupLayer));
        groupLayer.layers.forEach(layer => {
          // console.log("    Adding watch for sublayer ", layer.title);
          watchUtils.watch(layer, "visible", () => _onVisibilityChange(layer));
        });
      }
    });

    layerListExpand.expanded = true;
    tbExpand.expanded = true;

    zoomTo.init(view, zoomToExpand);

    const vars: { kr: string; BegSta: string; EndSta: string } = getUrlVars();
    if (vars.kr !== "") {
      // console.log("vars kr='" + vars.kr + "' begSta='" + vars.BegSta + "' endSta='" + vars.EndSta + "'");
      zoomTo.searchKeyRoute(vars.kr, vars.BegSta, vars.EndSta, true);
    }

    const vars2: { sn: string;} = getSnUrlVars();
    if (vars2.sn !== "") {
      // console.log("vars sn='" + vars2.sn);
      zoomTo.SearchStructure(vars2.sn);
    }


    setTimeout(checkForPrivileged, 100);

    setTimeout(watchGroupOpen, 100);

  } catch (error) {
    console.error("Error: in afterLayersLoad " + error.message);
  }
}

function getUrlVars(): { kr: string; BegSta: string; EndSta: string } {
  const vars: { kr: string; BegSta: string; EndSta: string } = { kr: "", BegSta: "", EndSta: "" };
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (substring: string, ...args: any[]): string => {
    vars[args[0]] = decodeURIComponent(args[1]);
    // console.log("getUrlVars = ", vars[args[0]]);
    return substring;
  });
  return vars;
}

function getSnUrlVars(): { sn: string} {
  const vars: { sn: string } = { sn: "" };
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (substring: string, ...args: any[]): string => {
    vars[args[0]] = decodeURIComponent(args[1]);
    // console.log("getUrlVars = ", vars[args[0]]);
    return substring;
  });
  return vars;
}

const appConfig = {
  // b2cScopes: ["https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"],

  // BIS / IROADS
  b2cScopes: ["https://ilgovb2c.onmicrosoft.com/openid"],

  // GIS Solutions
  // b2cScopes: ["https://iroadstestauth.onmicrosoft.com/hello/demo.read"],
  
  // ILGOV IHIS
  // b2cScopes: ["https://ilgovb2c.onmicrosoft.com/DOTInventoryFunctionsTest/call_functions openid profile"],
  // webApi: "https://localhost:5000/hello"
};

const msalConfig:Msal.Configuration = {
  auth: {
      // clientId: "e760cab2-b9a1-4c0d-86fb-ff7084abd902", //This is your client ID
      // authority: "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_susi", //This is your tenant info

      // BIS
      // clientId: 'e6813d45-f056-4b1e-befd-2f20d7fbf2f7',
      // authority:
      //   'https://ilgovb2c.b2clogin.com/tfp/ilgovb2c.onmicrosoft.com/B2C_1A_DOT_Ihis_signup_signin',
    
      // GIS Solutions Auth Test
      // clientId: "a8f66dab-f671-461d-9579-3de4b5397c80", // This is your client ID
      // authority: "https://iroadstestauth.b2clogin.com/iroadstestauth.onmicrosoft.com/B2C_1_signupsignin1", // This is your tenant info


      // IROADS Localhost:8080
      // B2C_1A_DOT_IROADS_signup_signin 
      // IROADS_Test 
      clientId:  process.env.B2C_CLIENT_ID ? process.env.B2C_CLIENT_ID : "", // "fefa6181-1aa2-4c5a-a6f2-d5f0e3247dd0", // new dev app id
      authority: "https://ilgovb2c.b2clogin.com/tfp/ilgovb2c.onmicrosoft.com/B2C_1A_DOT_IROADS_signup_signin", // This is your tenant info


      // ILGOVB2C, B2c_1a_dot-ihis_signup_signin
      // clientId: "3bcd9dee-1e09-4dae-85e0-18ffa4fbcc4b", //This is your client ID
      // authority: "https://ilgovb2c.b2clogin.com/ilgovb2c.onmicrosoft.com/b2c_1a_dot_ihis_signup_signin",             
      validateAuthority: false
  },
  cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true
  }
};

// instantiate MSAL
const myMSALObj = new Msal.UserAgentApplication(msalConfig);

// request to signin - returns an idToken
const loginRequest:Msal.AuthenticationParameters = {
  scopes: appConfig.b2cScopes,
  // redirectUri: "http://localhost:8080"
  // redirectUri: "https://webappstest.dot.illinois.gov/IROADS/redirect"
};

// request to acquire a token for resource access
// const tokenRequest:Msal.AuthenticationParameters = {
//   scopes: ["https://ilgovb2c.onmicrosoft.com/openid"], // , "https://ilgovb2c.onmicrosoft.com/offline_access"], // appConfig.b2cScopes,
  
//   prompt: "none",
//   // redirectUri: "http://localhost:4200/redirect"
// };

function authCallback(error:Msal.AuthError, response:Msal.AuthResponse) {
  // handle redirect response
  console.log("authCallback called", error, " response ", response);
  // getAuthToken();
  updateAuthStatus();
}

// signin and acquire a token silently with POPUP flow. Fall back in case of failure with silent acquisition to popup
export function signIn() {
  // check for IE
  const ua = window.navigator.userAgent;
  if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) {
    console.log("IE Detected - Using loginRedirect")
    myMSALObj.handleRedirectCallback(authCallback);
    myMSALObj.loginRedirect(loginRequest);
  } else {
    myMSALObj.loginPopup(loginRequest).then( (loginResponse) => {
      // For IROADS Don't get token, just updateUI
      // getAuthToken();
      updateAuthStatus(true);
      // getToken(tokenRequest).then(updateUI);
    }).catch( (error) => {
      updateAuthStatus();
      logMessage(error);
    });
  }
}

function checkForPrivileged() {
  // console.log("checkForPrivileged");

  const idotRoadsLayer = new FeatureLayer({
    url: layerSource.serverUrl,
    layerId: layerSource.IDOTRoadsLayer,
    visible: false,
    outFields: ["*"],
    title: "IDOT Roads"
  });

  idotRoadsLayer.load().then(() => {
    // console.log("idotRoadsLayer", idotRoadsLayer);
    if (idotRoadsLayer.getField("K2")) {
      if (idotRoadsLayer.getField("MU_EST")) {
        setIsPrivileged(false);
        setIsInternal(true);
      } else {
        setIsPrivileged(true);
        setIsInternal(false);
      }
    } else {
      setIsPrivileged(false);
      setIsInternal(false);
    }
    if (infoPane !== undefined) {
      infoPane.setAuthButton();
    }

  });
}

// updates the UI post login/token acquisition
function updateAuthStatus(reload:boolean = false) {
  loggedInAccount = myMSALObj.getAccount();
  // console.log("updateAuthStatus  account = ", loggedInAccount);

  const idToken = getUserAttributes("msal." + msalConfig.auth.clientId + ".idtoken");
  let expDate:Date = new Date();

  if (loggedInAccount !== null && loggedInAccount.idToken !== null) {
    try {
      const exp = (parseInt(loggedInAccount.idToken.exp, 10) + (60*60*24)) * 1000;  // 24 hours to expire.
      expDate = new Date(exp);
      // console.log("token expire ", expDate);
    } catch (error) {
      // just ignore errors
    }
  }

  if (idToken !== null && loggedInAccount !== undefined && loggedInAccount.name !== "" && expDate.valueOf() > Date.now()) {
    authLoggedIn = true;
    document.cookie = "iroads.msal.idtoken" + "=" + idToken + "; expires=Thu, 01 Jan 2070 00:00:01 GMT";
    setTimeout(checkForPrivileged, 100);
    // console.log("set token cookie ");
  } else {
    authLoggedIn = false;
    document.cookie = "iroads.msal.idtoken" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT";
    // console.log("cleared token cookie");
  }
  if (infoPane !== undefined) {
    infoPane.setAuthButton();
  }
  if (reload)
  {
    history.go(0);
  }
  else
  {
   loadAllLayers();
  }
}

// signout the user
export function logout() {
  // Removes all sessions, need to call AAD endpoint to do full logout
  myMSALObj.logout();
  // loadAllLayers();
}

// debug helper
function logMessage(s:string) {
  console.log(s);
}

function loadLayers() {
  // console.log("loadLayers cur # = " + view.map.layers.length.toString());
  view.map.add(otherLayers.otherLayersGroupLayer);
  view.map.add(boundaryLayers.boundaryLayersGroupLayer);
  view.map.add(trafficLayers.trafficCountGroupLayer);
  view.map.add(roadwayClassification.roadwayClassificationGroupLayer);
  view.map.add(structures.structuresGroupLayer);
  view.map.add(pavement.pavementGroupLayer);
  view.map.add(programming.programmingGroupLayer);
  view.map.add(baseGroup.baseGroupLayer);

  view.map.add(baseGroup.drawLayer);
  view.map.add(pinLayer);

  watchUtils.whenFalseOnce(view, "updating", () => {updatingDone();});
}

function loadAllLayers() {
  // console.log("loadAllLayers");
  try {

    if (view.map.layers.includes(pinLayer)) {
      view.goTo(illinoisExtent.expand(1.05));
      // console.log("Remove all layers");
      view.map.removeAll();
    } else {
      loadLayers();
    }
    } catch (error) {
      console.error("Error in loadAllLayers ", error.message);
  }
}

function setSelectLayer() {
  try {
    const selectLayer = document.getElementById("selectLayer");
    let curValue = "";
    const selectLayerList: HTMLSelectElement = document.getElementById("selectLayerList") as HTMLSelectElement;
    if (selectLayerList) {
      curValue = selectLayerList.value;
    }
    if (selectedLayersId.length === 1) {
      curValue = selectedLayersId[0]; // if one is selected, just select it
    }

    if (selectLayer) {
      let dropDownList = "Selection Layer : <select id='selectLayerList' style='width:250px'>\n";
      dropDownList += "<option key='None' value='None'></option>\n";

      if (selectedLayers) {
        for (let i = 0; i < selectedLayers.length; i++) {
          dropDownList +=
            "<option " +
            (curValue === selectedLayersId[i] ? "selected='selected' " : "") +
            "value='" +
            selectedLayersId[i] +
            "' " +
            "key='" +
            selectedLayersId[i] +
            "'>" +
            selectedLayers[i] +
            "</option>\n";
        }
      }

      dropDownList += "</select>\n";
      selectLayer.innerHTML = dropDownList;
    }
  } catch (error) {
    console.error("Error: in setSelectedLayer " + error.message);
  }
}

function addToSelectLayers(groupLayer: GroupLayer, selectLayers: string[], ids: string[], onlyMapImageLayers:boolean = false) {
  try {
    if (groupLayer.visible) {
      groupLayer.layers
        .slice()
        .reverse()
        .forEach(layer => {
          if (layer instanceof MapImageLayer) {
            const mapImageLayer: MapImageLayer = layer as MapImageLayer;
            if (mapImageLayer.visible && mapImageLayer.sublayers) {
              selectLayers.push(mapImageLayer.sublayers.getItemAt(0).title);
              ids.push(mapImageLayer.id);
            }
          } else if (!onlyMapImageLayers && layer instanceof FeatureLayer) {
            const featureLayer: FeatureLayer = layer as FeatureLayer;
            if (featureLayer.visible) {
              selectLayers.push(featureLayer.title);
              ids.push(featureLayer.id);
            }
          }
        });
    }
  } catch (error) {
    console.error("Error: in addtoSelectLayers " + error.message);
  }
}

// Add layers to the Selection Layers drop down list
function _onVisibilityChange(inLayer: any) {
  try {
    // console.log(" Visibility changed", inLayer.title);
    closeHover();
    pavement.roadConditionQueryLayer.visible = false;

    selectedLayers = [] as string[];
    selectedLayersId = [] as string[];

    if (pavement.pavementGroupLayer.visible) {
      pavement.pavementGroupLayer.layers
        .slice()
        .reverse()
        .forEach(layer => {
          const mapImageLayer: MapImageLayer = layer as MapImageLayer;
          if (mapImageLayer.visible && mapImageLayer.title !== "RoadConditionQueryLayer") {
            selectedLayers.push(mapImageLayer.title);
            switch (mapImageLayer.title.toLowerCase().slice(0,3)) {
              case "Rut".toLowerCase() :
              case "IRI".toLowerCase() :
              case "CRS".toLowerCase() :
                  selectedLayersId.push(pavement.roadConditionQueryLayer.id);
                  pavement.roadConditionQueryLayer.visible = true;
                  break;
              default:
                  selectedLayersId.push(mapImageLayer.id);
            }
          }
        });
    }

    if (inLayer instanceof MapImageLayer) {
      if (programming.programmingGroupLayer.layers.includes(inLayer)) {
        const featureLayer = programming.programmingFeatureLayers.get(inLayer.title);
        if (featureLayer) {
          featureLayer.visible = inLayer.visible;
        }
      }
    }

    addToSelectLayers(programming.programmingGroupLayer, selectedLayers, selectedLayersId, true);
    addToSelectLayers(structures.structuresGroupLayer, selectedLayers, selectedLayersId);
    addToSelectLayers(roadwayClassification.roadwayClassificationGroupLayer, selectedLayers, selectedLayersId);

    // addToSelectLayers(boundaryLayers.boundaryLayersGroupLayer, selectLayers, selectedLayersId);
    addToSelectLayers(otherLayers.otherLayersGroupLayer, selectedLayers, selectedLayersId);
    //        addToSelectLayers(trafficCount.trafficCountGroupLayer, selectLayers, selectedLayersId);

    setSelectLayer();
  } catch (error) {
    console.error("Error: in _onVisibilityChange " + error.message);
  }
}

let bgExpand:Expand;
let printExpand:Expand;
let maskExpand:Expand;
let infoExpand:Expand;
let zoomToExpand:Expand;
let searchExpand:Expand;
let coordExpand:Expand;

export function closeExpanded() {
  bgExpand.expanded = false;
  printExpand.expanded = false;
  maskExpand.expanded = false;
  infoExpand.expanded = false;
  zoomToExpand.expanded = false;
  //searchExpand.expanded = false;
  closeHover();
  // coordExpand.expanded = false;
}

export function closePopups() {
  view.popup.close();
}

function updatingDone() {
  // console.log("updating done ");
  
  const loader = document.getElementById("loadingImg") as HTMLImageElement;
  const lefts = document.getElementsByClassName('esri-ui-top-left');
  if (lefts.length > 0) {
    topLeft = lefts[0] as HTMLDivElement;
  }
  setTimeout(afterLayersLoad, 10);
  loader.classList.add("close");
  loader.style.visibility = "hidden"; 

}

// Put widgets on map view
export function setupMapView(viewIn: MapView) {
  // console.log("setupView start");
  view = viewIn;

  try {
    const url = layerSource.serverUrl as string;
    const origin = url.substr(0, url.indexOf("/arcgis"));
    const baseUrl = origin.substr(8);

    urlUtils.addProxyRule({
      urlPrefix: "services.hxgncontent.com",
      proxyUrl: process.env.IROADS_PROXY_URL as string
    });

    // If specify ending, don't use Proxy (IROADS_Public)
    if (baseUrl.indexOf("IROADS_") === -1) {

      urlUtils.addProxyRule({
        urlPrefix: baseUrl,
        proxyUrl: process.env.IROADS_PROXY_URL as string
      });
    }

    updateAuthStatus();

    // This is for re-loading layers after they are all removed
    view.map.layers.on("after-remove", (event) => {
      // console.log(event.item.title, " has been removed from the map.");
      if (event.item.title === "Push Pins") {
        // console.log("Push Pin removed, add other layers")
        loadLayers();
      }
    });

    view.popup.autoOpenEnabled = true;
    view.popup.highlightEnabled = true;

    // If it's a measure tool, dock to bottom, otherwise float.
    view.popup.watch("title", event => {
     // console.log("popup title changed ", view.popup.title)
    if (view.popup.title && view.popup.title.indexOf("Measure") === 0) {
        view.popup.dockEnabled = (navigator.appVersion.indexOf('Edge') === -1);  // only if not edge
        view.popup.set("dockOptions", {
          breakpoint: false,
          buttonEnabled: true,
          position: "bottom-center"
        });
      } else if (view.popup.title && view.popup.title.indexOf("Data") === 0) {
        view.popup.dockEnabled = (navigator.appVersion.indexOf('Edge') === -1);  // only if not edge
        view.popup.set("dockOptions", {
          breakpoint: false,
          buttonEnabled: true,
          position: "bottom-left"
        });
      } else if (view.popup.title && (
          // view.popup.title.indexOf("Pavement Condition") === 0 ||
          (view.popup.selectedFeature.layer !== null && 
            view.popup.selectedFeature.popupTemplate !== null &&
            view.popup.selectedFeature.popupTemplate.content !== null && 
            view.popup.selectedFeature.popupTemplate.content.toString().substr(0,6) === "<small"))) 
        {
        view.popup.dockEnabled = false;
        view.popup.set("dockOptions", {
          breakpoint: false,
          buttonEnabled: false,
          position: "bottom-left"
        });
      } else {
        view.popup.dockEnabled = (navigator.appVersion.indexOf('Edge') === -1);  // only if not edge
        view.popup.set("dockOptions", {
          breakpoint: false,
          buttonEnabled: true,
          position: "bottom-left"
        });
      }
    });

    view.popup.watch("features", event => {
      // console.log("view.popup.features change, ", view.popup.features.length);
      if (view.popup.features.length > 1) {
        try {

          const selectLayerList = document.getElementById("selectLayerList") as HTMLSelectElement;
          const selectLayerTitle = selectLayerList[selectLayerList.selectedIndex].label;

          if (selectLayerTitle !== "") {
            for (let f=0; f < view.popup.features.length; f++) {
              const graphic = view.popup.features[f];
              if (graphic.hasOwnProperty('sourceLayer') && graphic['sourceLayer'] && graphic['sourceLayer'].title === selectLayerTitle) {
                // console.log("set popup feature to selected layer ", f, " ", graphic['sourceLayer'].title);
                view.popup.selectedFeatureIndex = f;
                break;
              }
            }
          }

          // If not selected layer, just choose next non iroads layer as selected in popoup
          if (view.popup.selectedFeatureIndex <= 0) {
            for (let f=0; f < view.popup.features.length; f++) {
              const graphic = view.popup.features[f];
              if (graphic.hasOwnProperty('sourceLayer') && graphic['sourceLayer'] && graphic['sourceLayer'].title !== "IDOT Roads") {
                // console.log("set popup feature to ", f, " ", graphic['sourceLayer'].title);
                view.popup.selectedFeatureIndex = f;
                break;
              }
            }
          }
        } catch (error) {
          console.error("Error in view.popup.watch(features)", error)
        }
      }
    });

    view.popup.watch("selectedFeature", event => {
      // console.log("view.popup selectedFeature change, ", view.popup.selectedFeature);
      clearGraphicType(view, "selected");
      if (view.popup.selectedFeature) {

        if (view.popup.selectedFeature)
        {
          if (view.popup.selectedFeature.layer === null) {
            _highlightGeometry(view.popup.selectedFeature.geometry);
          }
          else
          {
            if (view.popup.selectedFeature.layer.title === "IDOT Roads")
            {
              // Show begin/end ref on map
              _addRefGraphic(view.popup.selectedFeature, true);
              _addRefGraphic(view.popup.selectedFeature, false);
            }
          }
        }

        if (clickPoint) {
          const clickGraphic = new Graphic({
            geometry: clickPoint,
            attributes: { type: "selected" },
            symbol: clickSymbol
          });
          baseGroup.drawLayer.add(clickGraphic);
        }
      }
    });


    view.popup.watch("visible", event => {
      // console.log("view.popup visible change, ", view.popup.visible);
      if (!view.popup.visible) {
        clearGraphicType(view, "selected");
      }
    });
    view.ui.remove("zoom");

    toolbar = new ToolBar({
      view,
      id: "Toolbar"
    });

    tbExpand = new Expand({
      view,
      id: "Toolbar Expand",
      content: toolbar,
      expanded: false,
      expandTooltip: "Toolbar",
      group: "toolbar",
      expandIconClass: "esri-icon-menu"
    });
    view.ui.add(tbExpand, "top-left");

    const homeWidget = new Home({
      view,
      id: "Home"
    });

    // adds the home widget to the top left corner of the MapView
    view.ui.add(homeWidget, {
      position: "top-left",
      index: 3
    });

    const zoom = new Zoom({
      view,
      id: "Zoom"
    });
    view.ui.add(zoom, "top-left");

    const scaleBar = new ScaleBar({
      view,
      id: "Scalebar"
    });

    // Add widget to the bottom left corner of the view
    view.ui.add(scaleBar, {
      position: "bottom-right",
      index: 1
    });

    if (layerSource.serverUrl && layerSource.serverUrl.search("webapps.dot.illinois.gov") < 0) {
      view.ui.add("vScale", {
        position: "bottom-right",
        index: 2
      })
    }

    loadBasemapGallery();

    printWidget = new Print({
      view,
      id: "Print",
      // printServiceUrl: origin + "/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
      printServiceUrl: process.env.PRINTSERVICE_URL
    });

    const val = getUserAttributes("IDOT_IROADS_print.templateOptions");
    const templateOptions = new TemplateOptions(val);
    if (templateOptions && templateOptions.hasOwnProperty("title")) {
      printWidget.templateOptions = templateOptions;
    }

    watchUtils.watch(printWidget.templateOptions, ["attributionEnabled", "title", "author", "copyright", "dpi", "legendEnabled", "format", "height", "layout", "legendEnabled", "scaleEnabled", "width"], (newValue, oldValue, propertyName, target) => {
      // console.log("Print templateOptions changed ", propertyName, ' from ', oldValue, ' to ', newValue, " target ", target);
      if (printWidget && printWidget.templateOptions) {
        const t = {attributionEnabled:printWidget.templateOptions.attributionEnabled, title:printWidget.templateOptions.title, author:printWidget.templateOptions.author, copyright:printWidget.templateOptions.copyright, dpi:printWidget.templateOptions.dpi, legendEnabled:printWidget.templateOptions.legendEnabled, format:printWidget.templateOptions.format, height:printWidget.templateOptions.height, layout:printWidget.templateOptions.layout, scaleEnabled:printWidget.templateOptions.scaleEnabled, width:printWidget.templateOptions.width};
        saveUserAttributes("IDOT_IROADS_print.templateOptions", t);
      }
    });

    printExpand = new Expand({
      expandTooltip: "Export",
      id: "Print Expand",
      view,
      content: printWidget,
      group: "left"
    });

    //  Adds widget below other elements in the top left corner of the view
    view.ui.add(printExpand, "top-left");

    // Hide roads layer when printing, show to highlight when selected.
    watchUtils.whenTrue(printExpand, "expanded", () => {
      // console.log("printExpand = true");
      baseGroup.iRoadsRenderer.symbol.color.a = 0;
      baseGroup.idotRoadsLayer.opacity = 0;
      closePopups();
    });

    watchUtils.whenFalse(printExpand, "expanded", () => {
      // console.log("printExpand = false");
      baseGroup.iRoadsRenderer.symbol.color.a = 0.01;
      baseGroup.idotRoadsLayer.opacity = 1;
    });

    const mask = new Mask(view);

    maskExpand = new Expand({
      view,
      id: "Mask Expand",
      content: mask,
      expanded: false,
      expandTooltip: "Mask It!",
      group: "left",
      expandIconClass: "esri-icon-collection"
    });
    watchUtils.whenTrue(maskExpand, "expanded", () => 
    {
      closePopups();
      mask.init();
    });
    view.ui.add(maskExpand, "top-left");

    infoPane = new Info();

    infoExpand = new Expand({
      view,
      id: "Info Expand",
      content: infoPane,
      expanded: false,
      expandTooltip: "Info / Help",
      group: "left",
      expandIconClass: "esri-icon-description"
    });
    watchUtils.whenTrue(infoExpand, "expanded", () => 
    {
      infoPane.init()
      closePopups();
    });

    view.ui.add(infoExpand, "top-left");

    infoPane.queryFeatureTable();

    zoomToExpand = new Expand({
      view,
      id: "Zoom To Expand",
      content: zoomTo,
      expanded: false,
      expandTooltip: "Zoom To",
      group: "left",
      expandIconClass: "esri-icon-filter"
    });
    watchUtils.whenTrueOnce(zoomToExpand, "expanded", () => zoomTo.searchTypeBtnPressed());
    watchUtils.whenTrue(zoomToExpand, "expanded", () => closePopups());

    view.ui.add(zoomToExpand, "top-left");

    const searchWidget = new Search({
      view,
      sources: buildSearchSources(),
      locationEnabled: false,
      includeDefaultSources: false,
      id: "Search"
    });

    searchExpand = new Expand({
      view,
      id: "Search Expand",
      content: searchWidget,
      expanded: false,
      expandTooltip: "Search",
      group: "left",
      expandIconClass: "esri-icon-search"
    });
    watchUtils.whenTrue(searchExpand, "expanded", () => closePopups());

    view.ui.add(searchExpand, "top-left");

    // Bookmarks Widget
    const coordinateWidget = new CoordinateConversion({ view });

    coordExpand = new Expand({
      view,
      id: "Coordinate Expand",
      content: coordinateWidget,
      expandTooltip: "Coordinate",
      group: "bottom-right",
      expandIconClass: "esri-icon-locate-circled"
    });

    view.ui.add(coordExpand, {
      position: "bottom-right",
      index: 2
    });

    layerList = new LayerList({
      view,
      listItemCreatedFunction: defineActions
    });

    layerList.on("trigger-action", event => {
      zoomToExpand.expanded = true;
      zoomTo.setSearchLayer(event.item.layer);
    });

    layerListExpand = new Expand({
      view,
      id: "LayerList Expand",
      expandIconClass: "esri-icon-layer-list",
      expandTooltip: "Planning",
      expanded: false,
      group: "top-right",
      content: layerList
    });

    view.ui.add(layerListExpand, {
      position: "top-right",
      index: 1
    });

    view.on("pointer-move", event => {
      // console.log("pointer-move", event);
      if (popupTimeout) {
        // console.log("cancel popupTimeout")
        clearTimeout(popupTimeout);        
        popupTimeout = null;
      }

      if (toolbar.activeTool === toolbar.panTool && (view.popup.visible === false || view.popup.dockEnabled === false)) {
        view.hitTest(event).then(checkHover);
      }
    });

    // view.on("pointer-enter", event => {
    //   console.log("pointer-enter", event);
    // });

    // view.on("pointer-leave", event => {
    //   console.log("pointer-leave", event);
    // });

    view.on("click", event => {
      // console.log("view on click");
      closeExpanded();
      if (toolbar.activeTool === toolbar.panTool) {
        if (topLeft && topLeft.offsetParent && event.x < 25 + topLeft.clientWidth && event.y < 15 + topLeft.clientHeight ) {
          event.stopPropagation();
        }
        clickPoint = event.mapPoint;
        clearGraphicType(view, "selected");

        // view.popup.close();
        // showPopup(event);
      } else {
        clickPoint = null;
      }
    })

    selectedLayers = [] as string[];
    selectedLayersId = [] as string[];
    setSelectLayer();
  } catch (error) {
    console.error("Error: in setupView " + error.message);
  }
}

function _addRefGraphic(graphic: Graphic, isBegin: boolean) {
  try {
    const begSta = Number(graphic.attributes.BEG_STA);
    const endSta = Number(graphic.attributes.END_STA);

    const newPolygon = webMercatorUtils.webMercatorToGeographic(graphic.geometry) as Polyline;
    const line = webMercatorUtils.geographicToWebMercator(newPolygon) as Polyline;
    let stationPoint;

    if (isBegin) { // If specify end point, use end point
      stationPoint = new Point({
        x: line.paths[0][0][0],
        y: line.paths[0][0][1],
        spatialReference: line.spatialReference
      });
    }
    else {
      stationPoint = new Point({
        x: line.paths[line.paths.length - 1][line.paths[0].length - 1][0],
        y: line.paths[line.paths.length - 1][line.paths[0].length - 1][1],
        spatialReference: line.spatialReference
      });
    }
    if (stationPoint) {
      const stationGraphic = new Graphic({
        symbol: new SimpleMarkerSymbol({
          style: "circle",
          color: isBegin ? "green" : "red",
          size: "18px"
        }),
        attributes: { type: "selected" },
        geometry: stationPoint
      });
      const stationTextGraphic = new Graphic({
        symbol: new TextSymbol({
          color: isBegin ? "green" : "red",
          text: isBegin ? begSta.toString() : endSta.toString(),
          xoffset: -17,
          yoffset: -17,
          font: {
            // autocast as new Font()
            size: 13,
            family: "sans-serif",
            weight: "bold"
          }
        }),
        attributes: { type: "selected" },
        geometry: stationPoint
      });

      baseGroup.drawLayer.add(stationTextGraphic);
      baseGroup.drawLayer.add(stationGraphic);
    }
  } catch (error) {
    console.error("Error: in _addRefGraphic " + error.message);
  }
}



function loadBasemapGallery() {
    // Create a BasemapGallery widget instance and set its container to a div
    // element


    // console.log("loadBasemapGaller, authIsInternal = ", authIsInternal);

    if (bgExpand) {
      view.ui.remove(bgExpand);
    }

    if (basemapGallery) {
      view.ui.remove(basemapGallery);
    }

    localBasemapsSourceInternal.basemaps.getItemAt(4).title = "Light Gray";
    localBasemapsSource.basemaps.getItemAt(4).title = "Light Gray";

    basemapGallery = new BasemapGallery({
      view,
      id: "Basemap",
      source: authIsInternal ? localBasemapsSourceInternal : localBasemapsSource
    });


    bgExpand = new Expand({
      view,
      id: "Basemap Expand",
      content: basemapGallery,
      expandTooltip: "Basemap",
      group: "left"
    });
    watchUtils.whenTrue(bgExpand, "expanded", () => closePopups());

    // Add the expand instance to the ui

    view.ui.add(bgExpand, {
      position: "top-left",
      index: 3
    });

    const selectedBasemap = getUserAttributes("IDOT_IROADS_selectedBasemap");
    // console.log("selected user basemap = ", selectedBasemap);
    if (!selectedBasemap || selectedBasemap >= basemapGallery.source.basemaps.length) {
      view.map.basemap = basemapGallery.source.basemaps.getItemAt(0);
    } else {
      view.map.basemap = basemapGallery.source.basemaps.getItemAt(selectedBasemap);
    }
    if (!authIsInternal && basemapGallery.activeBasemap.title.indexOf("Hexagon") !== -1) {
      view.map.basemap = basemapGallery.source.basemaps.getItemAt(0);
    }

    /**********************
     *
     * Close basemapGallery expand widget when basemap is clicked
     */
    basemapGallery.watch("activeBasemap", event => {
      // console.log("Basemap click");
      if (basemapGallery.activeBasemap) {
        saveUserAttributes(
          "IDOT_IROADS_selectedBasemap",
          basemapGallery.source.basemaps.findIndex(basemap => {
            return basemap.id === basemapGallery.activeBasemap.id;
          })
        );
        bgExpand.collapse();
      }
    });
}

function _highlightGeometry(geometry: Geometry) {
  try {
    let selectedGraphic:Graphic;
    if (geometry.extent) {
      selectedGraphic = new Graphic({
        geometry,
        attributes: { type: "selected" },
        symbol: new SimpleLineSymbol({
          color: highlightColor,
          width: 5 // points
        })
      });
      baseGroup.drawLayer.add(selectedGraphic);
    } else {
      selectedGraphic = new Graphic({
        geometry,
        attributes: { type: "selected" },
        symbol: new SimpleMarkerSymbol({
          style: "circle",
          color: "orange",
          size: "15px",
          outline: {
            color: [255, 255, 0],
            width: 3
          }
        })
      });
      baseGroup.drawLayer.add(selectedGraphic);
    }
  } catch (error) {
    console.error("Error: in _highlightGeometry " + error.message);
  }
}    

let popupTimeout:NodeJS.Timeout|null = null;

function checkHover(response:__esri.HitTestResult) {
  try {
    if (response.results.length > 0) {
      const features = [] as Graphic[];
      response.results.forEach((value, index, results) => {
        let layerTitle = value.graphic.layer.title;
        if (value.graphic.layer instanceof FeatureLayer) {
          layerTitle = value.graphic.layer.sourceJSON.name;
        }
        const feature = value.graphic;
        if (layerTitle && layerTitle !== "IDOT Roads") {
          // console.log("Hit test found ", layerTitle);
          let improvements = "";
          for (let i=1; i<12; i+=2) {
            const iFeat = "Improvem_" + i;
            if (feature.attributes[iFeat] && feature.attributes[iFeat].trim() !== "") {
              improvements += (i>1 ? ", " : "") + feature.attributes[iFeat];
            }
          }
          let route = "";
          for (let i=1; i<12; i++) {
            const iFeat = "Route" + i;
            if (feature.attributes[iFeat] && feature.attributes[iFeat].trim() !== "") {
              route += (i>1 ? ", " : "") + feature.attributes[iFeat];
            }
          };
          const fiscalYear = "";
          // if (feature.attributes.Publicatio && feature.attributes.Publicatio.substr(0,2) !== "20") {
          //   fiscalYear = feature.attributes.Publicatio.substr(0,4);
          // }
          const markedRt = feature.attributes.MARKED_RT;
          let showPopupDialog = false;

          const selectLayerList: HTMLSelectElement = document.getElementById("selectLayerList") as HTMLSelectElement;
          for (let e=0; e < selectLayerList.options.length; e++) {
            if (markedRt && selectLayerList.options[e].label.indexOf(" Marked") > 0) {
              showPopupDialog = true;
            }
            if (!markedRt && selectLayerList.options[e].label.indexOf(" Unmarked") > 0) {
              showPopupDialog = true;
            }
          }

          if (layerTitle.toLowerCase() === pavement.roadConditionQueryLayer.title.toLowerCase() && showPopupDialog) {
            feature.popupTemplate = new PopupTemplate ({
              title: "Pavement Condition",
              content: "<small><b>Key Route:</b> " + feature.attributes.INVENTORY + " <b>Station: </b>" + feature.attributes.BEG_STA + " - " + feature.attributes.END_STA + "<br/>" + 
              "<b>Inventory Direction:</b> (<span class='with_text'>With</span>&nbsp;|&nbsp;<span class='opp_text'>Opposing</span>) " + 
              "<b>Year: </b>" +  feature.attributes.CRS_YR + "<br/>" + 
              "<b>CRS:</b> <span class='with_text'>" + feature.attributes.CRS_WITH.toFixed(1) + "</span>&nbsp;|&nbsp;<span class='opp_text'>" + feature.attributes.CRS_OPP.toFixed(1) + "</span> " + 
              "<b>IRI:</b> <span class='with_text'>" + feature.attributes.IRI_WITH + "</span>&nbsp;|&nbsp;<span class='opp_text'>" + feature.attributes.IRI_OPP + "</span> " + 
              "<b>RUT:</b> <span class='with_text'>" + feature.attributes.RUT_WITH.toFixed(2) + "</span>&nbsp;|&nbsp;<span class='opp_text'>" + feature.attributes.RUT_OPP.toFixed(2) + "</span> " +
              "<b>Fault:</b> <span class='with_text'>" + feature.attributes.FAULT_WITH.toFixed(2) + "</span>&nbsp;|&nbsp;<span class='opp_text'>" + feature.attributes.FAULT_OPP.toFixed(2) + "</span></br> " +
              "<b>Distress: </b> <span class='with_text'>" + feature.attributes.DTRESS_WTH + "</span>&nbsp;|&nbsp;<span class='opp_text'>" + feature.attributes.DTRESS_OPP + "</span></small>"
            });
            features.push(feature);
          } else if (selectedLayers.includes(layerTitle)) {
            // console.log("hit test results layer=", layerTitle, " index ", index);
            if (layerTitle.substr(0,6) === "Annual" || layerTitle.substr(0,3) === "MYP") {
              feature.popupTemplate = new PopupTemplate ({
                title: layerTitle + (fiscalYear !== "" ? " FY" + fiscalYear : ""),
                content: "<small><b>PPS #:</b> " + feature.attributes.PPSProject + "<br/>" +
                "<b>INV:</b> " + feature.attributes.GISRouteKe + " " + feature.attributes.BeginMile + " to " + feature.attributes.EndMile + "<br/>" + 
                "<b>Location:</b> " + feature.attributes.Location + "<br/>" + 
                "<b>Route:</b> " + route + "<br/>" + 
                "<b>Est Cost:</b> " + feature.attributes.EstimatedC + "<br/>" + 
                ((feature.attributes.StructureN && feature.attributes.StructureN.trim() !== "") ? "<b>Feature:</b> " + feature.attributes.StructureN + "<br/>" : "") + 
                "<b>Improvements:</b> " + improvements + 
                "</small>"
              });
              features.push(feature);
            } else if (layerTitle.substr(0,3) === "FTR") {
              feature.popupTemplate = new PopupTemplate ({
                title: layerTitle,
                content: "<small><b>PPS #:</b> " + feature.attributes.PPSProject + "<br/>" +
                "<b>INV:</b> " + feature.attributes.GISRouteKe + " " + feature.attributes.BeginMile + " to " + feature.attributes.EndMile + "<br/>" + 
                "<b>Location:</b> " + feature.attributes.Location + "<br/>" + 
                "<b>Route:</b> " + route + "<br/>" + 
                "<b>Award Amount:</b> " + feature.attributes.AwardAmoun + "<br/>" + 
                ((feature.attributes.StructureN && feature.attributes.StructureN.trim() !== "") ? "<b>Feature:</b> " + feature.attributes.StructureN + "<br/>" : "") + 
                "<b>FY:</b> " + feature.attributes.Publicat_1 + "<br/>" +  
                ((feature.attributes.ContractNu && feature.attributes.ContractNu.trim() !== "") ? "<b>Contract Number:</b> " + feature.attributes.ContractNu + "<br/>" : "") +
                "<b>Improvements:</b> " + improvements + 
                "</small>"
              });
              features.push(feature);
            } 
          }
        }
      });
      if (features.length) {
        if (popupTimeout) {
          // console.log("cancel popupTimeout");
          clearTimeout(popupTimeout);
          popupTimeout = null;
        }

        popupTimeout = setTimeout( () => {
          try {
          clickPoint = null;
          view.popup.open({
            features,
            location: response.results[0].mapPoint
          });
        } catch (error) {
          console.error("Error in popupTimeout = setTimeout " + error.message);
        }
        }, 250);
      }
    } else {
      closeHover();
    }
  } catch (error) {
    console.error("Error in checkHover " + error.message);
  }
}

function closeHover() {
  try {
    // console.log("Close Hover");
    if (view.popup.visible && view.popup.content && view.popup.content instanceof Feature) {
      const content = view.popup.content as Feature 
      if (view.popup.visible && content.graphic && content.graphic.popupTemplate && content.graphic.popupTemplate.content && 
          typeof(content.graphic.popupTemplate.content) === "string" && content.graphic.popupTemplate.content.substr(0,6) === ("<small")) {
        // console.log("Closed Hover");
        view.popup.close();
      }
    }
  } catch (error) {
    console.error("Error in closeHover " + error.message);
  }
}

function buildSearchSources() {
  const illinoisLocator = new LocatorSearchSource({
    url: "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
    maxResults: 6,
    maxSuggestions: 6,
    minSuggestCharacters: 3,
    suggestionsEnabled: true,
    autoNavigate: true,
    singleLineFieldName: "SingleLine",
    filter: { geometry: illinoisExtent },
    countryCode: "US",
    outFields: ["Addr_type"],
    name: "Address or place",
    placeholder: "Find address or place"
  });
  // const stateStructures = new FeatureLayerSearchSource({
  //     featureLayer: structures.stateStructuresLayer,
  //     searchFields: ["SN"],
  //     displayField: "SN",
  //     exactMatch: false,
  //     outFields: ["*"],
  //     autoNavigate: true,
  //     name: "State Structures",
  //     placeholder: "example: 002-0035",
  //     maxResults: 6,
  //     maxSuggestions: 6,
  //     suggestionsEnabled: true,
  //     minSuggestCharacters: 3
  // });
  // const localStructures = new FeatureLayerSearchSource({
  //     featureLayer: structures.localStructuresLayer,
  //     searchFields: ["SN"],
  //     displayField: "SN",
  //     exactMatch: false,
  //     outFields: ["*"],
  //     autoNavigate: true,
  //     name: "Local Structures",
  //     placeholder: "example: 002-3035",
  //     maxResults: 6,
  //     maxSuggestions: 6,
  //     suggestionsEnabled: true,
  //     minSuggestCharacters: 3
  // });
  // const idotDistrictsFeatureLayer = new FeatureLayer({
  //     url: layerSource.serverUrl,
  //     layerId: layerSource.IDOTDistrictsLayer,
  //     outFields: ["*"]
  // });
  // watchUtils.init(idotDistrictsFeatureLayer, "loaded", () => { BuildPopups.buildPopupIfLoaded(idotDistrictsFeatureLayer as FeatureLayer); });
  // const idotDistricts = new FeatureLayerSearchSource({
  //     featureLayer: idotDistrictsFeatureLayer,
  //     autoNavigate: true,
  //     searchFields: ["DISTRICT"],
  //     displayField: "DISTRICT",
  //     exactMatch: true,
  //     outFields: ["*"],
  //     name: "IDOT Districts",
  //     placeholder: "example: 6",
  //     maxResults: 6,
  //     maxSuggestions: 6,
  //     suggestionsEnabled: true,
  //     minSuggestCharacters: 1
  // });
  // const countiesFeatureLayer = new FeatureLayer({
  //     url: layerSource.serverUrl,
  //     layerId: layerSource.IllinoisCountiesLayer,
  //     outFields: ["*"]
  // });
  // watchUtils.init(countiesFeatureLayer, "loaded", () => { BuildPopups.buildPopupIfLoaded(countiesFeatureLayer as FeatureLayer); });
  // const counties = new FeatureLayerSearchSource({
  //     featureLayer: countiesFeatureLayer,
  //     autoNavigate: true,
  //     searchFields: ["NAME_LC", "STATE_CODE"],
  //     displayField: "NAME_LC",
  //     suggestionTemplate: "{NAME_LC} ({STATE_CODE})",
  //     exactMatch: false,
  //     outFields: ["*"],
  //     name: "Illinois Counties",
  //     placeholder: "example: Shelby or 87",
  //     popupTemplate: boundaryLayers.illinoisCountiesPopupTemplate,
  //     maxResults: 6,
  //     maxSuggestions: 6,
  //     suggestionsEnabled: true,
  //     minSuggestCharacters: 2
  // });
  // const townsFeatureLayer = new FeatureLayer({
  //     url: layerSource.serverUrl,
  //     layerId: layerSource.IllinoisTownsLayer,
  //     outFields: ["*"]
  // });
  // watchUtils.init(townsFeatureLayer, "loaded", () => { BuildPopups.buildPopupIfLoaded(townsFeatureLayer as FeatureLayer); });
  // const towns = new FeatureLayerSearchSource({
  //     featureLayer: townsFeatureLayer,
  //     autoNavigate: true,
  //     searchFields: ["IDOT_NAME", "IDOT_MUNI"],
  //     displayField: "IDOT_NAME",
  //     suggestionTemplate: "{IDOT_NAME} ({IDOT_MUNI})",
  //     exactMatch: false,
  //     outFields: ["*"],
  //     name: "Illinois Towns",
  //     placeholder: "example: Alsip or 0095",
  //     popupTemplate: boundaryLayers.illinoisTownsPopupTemplate,
  //     maxResults: 6,
  //     maxSuggestions: 6,
  //     suggestionsEnabled: true,
  //     minSuggestCharacters: 2
  // });
  return [illinoisLocator]; // , stateStructures, localStructures, counties, towns];
}

// function getTitle(layer: any) {
//   let selectedLayer = layer;

//   if (selectedLayer instanceof MapImageLayer) {
//     const mapImageLayer: MapImageLayer = selectedLayer as MapImageLayer;
//     if (mapImageLayer && mapImageLayer.sublayers.length > 0) {
//       selectedLayer = mapImageLayer.sublayers.getItemAt(0);
//       // If it's one of the program layers, use the 3rd layer as the selectable layer (i.e. CRS Marked);
//       if (mapImageLayer.sublayers.length > 2) {
//         selectedLayer = mapImageLayer.sublayers.getItemAt(1);
//       }
//     }
//   }

//   return selectedLayer.title;
// }

export function clearGraphicType(viewIn: MapView, type: string) {
  try {
    for (let i = baseGroup.drawLayer.graphics.length - 1; i >= 0; i--) {
      const graphic = baseGroup.drawLayer.graphics.getItemAt(i);
      if (graphic && graphic.attributes && graphic.attributes.type && graphic.attributes.type === type) {
        // console.log("removing graphic type ", type)
        baseGroup.drawLayer.graphics.removeAt(i);
      }
    }
    for (let i = viewIn.graphics.length - 1; i >= 0; i--) {
      const graphic = viewIn.graphics.getItemAt(i);
      if (graphic && graphic.attributes && graphic.attributes.type && graphic.attributes.type === type) {
        // console.log("removing graphic type ", type)
        viewIn.graphics.removeAt(i);
      }
    }
  } catch (error) {
    console.error("Error: in clearGraphicType " + error.message);
  }
}

// Save user data to cookie
export function saveUserAttributes(group: string, value: any) {
  try {
    localStorage.setItem(group, JSON.stringify(value));
  } catch (error) {
    console.error("Error: in saveUserAttributes " + error.message);
  }
}

export function  getUserAttributes(group: string): any {
  try {
    const value = localStorage.getItem(group);
    if (value) {
      if ((value.substr(0,1) === "{" && value.substr(value.length-1,1) === "}") ||
          (value.substr(0,1) === "[" && value.substr(value.length-1,1) === "]")) {
        return JSON.parse(value);
      } else {
        return value;
      }
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error: in getUserAttributes " + error.message);
  }
}

export function returnSearchParamsFromLayer(layer: Layer) {
  // console.log("returnSearchParamsFromLayer ", layer);
  if (layer instanceof MapImageLayer)
  {
    const mapImageLayer = (layer as MapImageLayer);
    if (mapImageLayer.sublayers.length > 0)
    {
      return returnSearchParamsFromId(mapImageLayer.sublayers.getItemAt(0).id);
    }
  }
  const id = parseInt(layer.id, 10);
  if (id >=0 && id <= 999)
  {
    return returnSearchParams(layer.id);
  }
  if (layer instanceof FeatureLayer)
  {
    const featureLayer = layer as FeatureLayer;
    return returnSearchParamsFromId(featureLayer.layerId);
  }
  return returnSearchParams("");
}

export function returnSearchParamsFromId(id: number) {
  return returnSearchParams(id.toString());
}

export function returnSearchParams(layerId: string) {
  let promptStr = "";
  let searchField = "";
  let suffixStr = "";
  let numericField = true;

  // console.log("returnSearchParams ", layerId);
  if (layerId !== null && layerId !== "")
  {
    switch (layerId) {
      case structures.structuresGroupLayer.id:
      case layerSource.StateStructuresGroup.toString():
      case layerSource.StateStructuresLayer.toString():
      case layerSource.LocalStructuresLayer.toString():
        promptStr = "Structure (002-0035)";
        searchField = "SN";
        numericField = false;
        break;

      case layerSource.IDOTDistrictsLayer.toString():
        promptStr = "IDOT District (1-9)";
        searchField = "DISTRICT";
        break;

      case layerSource.IlHouseBoundariesLayer.toString():
        promptStr = "IL House District (1-118) (2023)";
        searchField = "DISTRICT";
        break;
  
      case layerSource.ILSenateBoundariesLayer.toString():
        promptStr = "IL Senate District (1-59) (2023)";
        searchField = "DISTRICT";
        break;

      case layerSource.IllinoisCountiesLayer.toString():
        promptStr = "County (Shelby)";
        searchField = "NAME_LC";
        numericField = false;
        break;

      case layerSource.MPOAreasLayer.toString():
        promptStr = "MPO Area (Decatur)";
        searchField = "MPO_NAME";
        numericField = false;
        break;

      case layerSource.PoliticalTownshipsLayer.toString():
        promptStr = "Township (Gilmer)";
        searchField = "NAME";
        suffixStr = " twp";
        numericField = false;
        break;

      case layerSource.UrbanAreasLayer.toString():
        promptStr = "Urban Area (Dixon)";
        searchField = "URBAN_NAME";
        numericField = false;
        break;

      case layerSource.IllinoisTownsLayer.toString():
        promptStr = "Town Name (Alsip)";
        searchField = "IDOT_NAME";
        numericField = false;
        break;
      
      case layerSource.USCongressBoundariesLayer.toString():
        promptStr = "US House District (1-17) (2023)";
        searchField = "DISTRICT";
        break;

      case layerSource.FTRStructuresLayer.toString():
      case layerSource.FTREngineeringLayer.toString():
      case layerSource.FTRLandAcqLayer.toString():
      case layerSource.FTRConstructionLayer.toString():
      case layerSource.AnnualBridgeImprovement.toString():
      case layerSource.AnnualEngineeringLayer.toString():
      case layerSource.AnnualLandAcqLayer.toString():
      case layerSource.AnnualConstructionLayer.toString():
      case layerSource.MYPStructuresLayerCurYear.toString():
      case layerSource.MYPStructuresLayerFutureYears.toString():
      case layerSource.MYPRoadwayLayerCurYear.toString():
      case layerSource.MYPRoadwayLayerFutureYears.toString():
      case layerSource.MYPSpotLayerCurYear.toString():
      case layerSource.MYPSpotLayerFutureYears.toString():
      case layerSource.ProgrammingDataGroup.toString():
      case programming.programmingGroupLayer.id:
        promptStr = "Enter PPS Number";
        searchField = "PPSProject";
        numericField = false;
        break;

      case layerSource.PavementConditionGroup.toString():
      case pavement.pavementGroupLayer.toString():
        promptStr = "Enter Key Route";
        searchField = "KeyRoute";
        numericField = false;
        break;
      default:
        // console.log("Can't file search params for ", layerId);
        break;
      }
    }
  return {
    prompt: promptStr,
    search: searchField,
    suffix: suffixStr,
    numeric: numericField
  };
}
